import { useMemo } from "react";
import { firstBy } from "thenby";
import { Group } from "contexts/GroupsContext/GroupsContext";
import useNaturalSort from "hooks/useNaturalSort";
import useTableSort from "providers/TableSortProvider/useTableSort";

function useSortGroups(groups: Group[]) {
  const naturalCompare = useNaturalSort();
  const sortBy = useTableSort();

  return useMemo(() => {
    return groups.slice().sort(
      sortBy.key === "name"
        ? firstBy("name", { cmp: naturalCompare, ignoreCase: true, direction: sortBy.direction })
        : firstBy(sortBy.key, { ignoreCase: true, direction: sortBy.direction }).thenBy("name", {
            cmp: naturalCompare,
          })
    );
  }, [naturalCompare, groups, sortBy.direction, sortBy.key]);
}

export default useSortGroups;
